import { getClientPath } from '@app/modules/ClientsProfile'

export function getPrintViewPath(id: number | string) {
  return `${getClientPath(id)}/druckansicht`
}
